import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Row, Space, Input, Typography } from 'antd';

import { SelectInput } from '../SelectInput';
import { TabelaEditar } from './TabelaEditar';

import { useMatrizConsulta } from '../context';

import * as S from './styles';

export function CollapseCustom() {
  const {
    clienteLista,
    updateMatriz,
    updateValidarMatriz,
    matrizEditItem,
    isEditMatriz,
  } = useMatrizConsulta();
  const [height, setHeight] = useState(0);
  const [idCliente, setIdCliente] = useState(null);
  const [nameCliente, setNameCliente] = useState(null);
  const [nomeMatriz, setNomeMatriz] = useState('');
  const { Text } = Typography;
  const collapseRef = useRef([]);

  const matrizEditObj = useCallback(() => {
    const { nome, idCliente, cliente } = matrizEditItem;

    if (isEditMatriz) {
      setNomeMatriz(nome);
      setIdCliente(idCliente);
      setNameCliente(cliente?.nomeFantasia);
    }
  }, [isEditMatriz, matrizEditItem]);

  const handlerChangeSelect = value => {
    setIdCliente(value);
    setNameCliente(value);
  };

  const handlerChangeInput = value => setNomeMatriz(value.target.value);

  useEffect(() => {
    setHeight(collapseRef?.current?.scrollHeight || 0);
  }, []);

  useEffect(() => {
    if (!!idCliente && nomeMatriz?.trim()?.length >= 2) updateValidarMatriz(true);

    if (nomeMatriz?.trim()?.length < 2) updateValidarMatriz(false);
  }, [idCliente, nomeMatriz, updateValidarMatriz]);

  useEffect(() => {
    matrizEditObj();
  }, [matrizEditItem, matrizEditObj]);

  useEffect(() => {
    const matrizFinal = {
      ...matrizEditItem,
      nome: nomeMatriz,
      idCliente,
    };
    updateMatriz(matrizFinal);
  }, [nomeMatriz, idCliente, matrizEditItem, updateMatriz]);

  return (
    <Row>
      <S.CollapseContainer>
        <S.CollapseHeader>
          <S.ContainerActions>
            <S.ColTitleCollapse>
              <Text className="text-title">Cliente</Text>
              <SelectInput
                options={clienteLista || []}
                valueSelec="nomeFantasia"
                select="id"
                value={nameCliente}
                handlerChange={handlerChangeSelect}
                placeholder="Selecione um cliente"
              />
            </S.ColTitleCollapse>
            <S.ColTitleCollapse>
              <Text className="text-title">Nome</Text>
              <Input
                placeholder="Dê um nome a matriz"
                onChange={handlerChangeInput}
                value={nomeMatriz || ''}
                className="style-input-nome"
              />
            </S.ColTitleCollapse>
            <S.ColTitleCollapse>
              {matrizEditItem?.id && (
                <>
                  <Text className="text-title">ID</Text>
                  <Space className="content-id">
                    <Text className="text-id">{matrizEditItem?.id || ''}</Text>
                  </Space>
                </>
              )}
            </S.ColTitleCollapse>
          </S.ContainerActions>
        </S.CollapseHeader>
        <S.CollapseBody
          style={{
            maxHeight: height,
          }}
          ref={el => (collapseRef.current = el)}
        >
          <S.CollapseContent>
            <TabelaEditar scroll={height} />
          </S.CollapseContent>
        </S.CollapseBody>
      </S.CollapseContainer>
    </Row>
  );
}
